<button class="close-top-button" (click)="close()" *ngIf="!data.hideCloseButton">
  <span class="material-symbols-outlined">close</span>
</button>
<div class="mx-[28px]">
  <p *ngIf="data.title" class="tb-dialog-title mt-1 mx-4">{{ data.title | translate }}</p>
</div>
<div mat-dialog-content [ngClass]="{'tb-dialog-nottitle': !data.title }">

  <div *ngIf="!data.hideAlertIcon" class="m-4 flex flex-1 justify-center">
    <img src="/assets/img/complete.svg" alt="" />
  </div>

  <div *ngIf="data.showSpinner" class="m-4 flex flex-1 justify-center">
    <mat-spinner [diameter]="50"></mat-spinner>
  </div>

  <p class="mb-2" *ngIf="data.message">{{ data.message | translate: data.messageParams }}</p>
  
  <ng-container *ngIf="data.componentName" #childContainer="ngComponentOutlet"
    [ngComponentOutlet]="data.componentName" [ngComponentOutletInputs]="data.componentData"></ng-container>
  
  <!-- simple input -->
  <form [formGroup]="modalForm" *ngIf="data.showInput">
    <mat-form-field class="w-full" *ngIf="!data.allowedInput">
      <mat-label>{{ (data.inputPlaceholder || '') | translate }}</mat-label>
      <input matInput formControlName="input" />
    </mat-form-field>
    <!-- auto complete input -->
    <app-autocomplete *ngIf="data.allowedInput && !data.allowedInputMode" class="w-full"
      formControlName="input"
      [label]="(data.inputPlaceholder || 'selectFomrList')" [options]="data.allowedInput" [requireMatch]="requireMatch"
      (onSelect)="onOptionSelected($event)"></app-autocomplete>
    <div class="flex flex-col max-h-70 overflow-y-auto pb-[2px]" formArrayName="selections"
      *ngIf="data.allowedInput && data.allowedInputMode == 'checkbox'">
      <div class="flex flex-col gap-4">      
        <div *ngFor="let option of data.allowedInput; let i = index" class="tb-card">
          <div class="p-2">
            <app-checkbox 
              [label]="option" [formControlName]="i"></app-checkbox>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>
<div mat-dialog-actions *ngIf="!data.hideDialogActions">
  <button *ngFor=" let btn of data.buttons" mat-raised-button
    [disabled]="data.showInput && !modalForm.valid && btn.label != 'close'" [color]="btn.color || ''"
    (click)="onClick(btn)">
    {{ btn.label | translate}}
  </button>
</div>
